module.exports = __webpack_public_path__ + "img/img_innovation6.454d41c2.png";